import { useState } from "react";
import { useQuery } from "@apollo/client";
import {
  GetBatchDisbursementsQuery,
  GetBatchDisbursementsQueryVariables,
} from "generated/graphql";
import queries from "Shared/queries";

export const BATCH_DISBURSEMENTS_PER_PAGE = 10;

export const useBatchDisbursements = () => {
  const [page, setPage] = useState(1);
  const { data, loading, error } = useQuery<
    GetBatchDisbursementsQuery,
    GetBatchDisbursementsQueryVariables
  >(queries.GET_BATCH_DISBURSEMENTS, {
    variables: {
      page,
      perPage: BATCH_DISBURSEMENTS_PER_PAGE,
    }
  });

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  return {
    batchDisbursements: data?.batchDisbursements,
    loading,
    error,
    page,
    rowsPerPage: BATCH_DISBURSEMENTS_PER_PAGE,
    handlePageChange,
  };
};
